import { Action } from "./actions"
import { ACTION_TYPES, Actions } from "./types"

export const INVENTORY_LOCATION_ACTION_TYPES = ACTION_TYPES
export const InventoryLocationAction = Action
export type InventoryLocationActions = Actions




// WEBPACK FOOTER //
// ./src/state/inventory/location/actions/index.ts